module.exports = __webpack_public_path__ + "static/media/logo-Pam-superstore.9f91a30e.png";